"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(type, min) {
  if (min < 0) {
    // somehow Apple has managed to release 13 versions of iOS and there's still no number keypad with a - sign
    // so we have to fallback to the alpha keyboard.
    return 'text';
  }

  return type === 'integer' ? 'numeric' : 'decimal';
};

exports.default = _default;